import React from "react"

import Button from "../../../design-system/button"
import { useLegalDisbursementsContext } from "../../../utils/contexts/legal-disbursements-context"

interface Props {
  className?: string
  buttonLocation?: string
  size?: "medium" | "large"
  fullWidth?: boolean
}

const LegalDisbursementModalButton = ({
  className,
  buttonLocation,
  size,
  fullWidth,
  ...props
}: Props) => {
  const { setIsLegalDisbursementsModalOpen } = useLegalDisbursementsContext()

  return (
    <Button
      size={size || "large"}
      as="button"
      onClick={() => setIsLegalDisbursementsModalOpen(true)}
      trackingProperties={{
        buttonName: "Book a legal disbursements demo",
        buttonLocation: buttonLocation || "body",
        buttonPosition: "1",
      }}
      data-testid={`book-a-legal-disbursements-demo-${buttonLocation}`}
      className={className}
      fullWidth={fullWidth}
      {...props}
    >
      Book a demo
    </Button>
  )
}

export default LegalDisbursementModalButton
